import script from "./TermsAndConditions.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsAndConditions.vue?vue&type=script&setup=true&lang=ts"

import "./TermsAndConditions.vue?vue&type=style&index=0&id=d9046b64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9046b64"]])

export default __exports__